// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Nj4b","footer":"ModalCreateQualiphyProcedure_footer__2icRC","additionData":"ModalCreateQualiphyProcedure_additionData__i9Dpx"};